export default __webpack_public_path__ + "react/static/joystick-701d5fae24723c6b7c2423f848856cb9.png";